<template>
  <div class="container">
    <div class="columns">
      <div class="column is-12">
        <h4 class="page-header">
          <b-icon icon="briefcase"></b-icon>
          <span v-if="form.id">{{ form.bookmaker }}</span>
          <span v-if="!form.id">{{ $ml.get('titles_bookies_new') }}</span>
        </h4>
      </div>
    </div>
    <form @submit.prevent="submit" novalidate>
      <b-loading :is-full-page="false" v-model="loading" :can-cancel="false"></b-loading>
      <div class="columns is-centered">
        <div class="column is-4">
          <b-field
              :label="$ml.get('strategies_bookmaker') + ' *'"
              :message="'bookmaker' in errors ? errors['bookmaker'] : $ml.get('strategies_bookmaker_placeholder')"
              :type="'bookmaker' in errors ? 'is-danger' : ''" class="plate">
            <b-select v-model="form.bookmaker" icon="tag" expanded :disabled="form.id">
              <option v-for="option in bookmakers" :value="option" :key="option"
                      v-if="form.id ? form.bookmaker === option : usedBookies.indexOf(option) === -1">
                {{ option }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-2">
          <b-field
              :label="$ml.get('bookies_min_payments') + ' *'" class="plate"
              :message="'min_payments' in errors ? errors['min_payments'] : ''"
              :type="'min_payments' in errors  ? 'is-danger' : ''">
            <b-input v-model="form.min_payments" icon="currency-usd-circle"></b-input>
          </b-field>
        </div>
        <div class="column is-2">
          <b-field
              :label="$ml.get('bookies_price7') + ' *'" class="plate"
              :message="'price7' in errors  ? errors['price7'] : ''"
              :type="'price7' in errors ? 'is-danger' : ''">
            <b-input v-model="form.price7" icon="currency-usd-circle"></b-input>
          </b-field>
        </div>
        <div class="column is-2">
          <b-field
              :label="$ml.get('bookies_price30') + ' *'" class="plate"
              :message="'price30' in errors  ? errors['price30'] : ''"
              :type="'price30' in errors ? 'is-danger' : ''">
            <b-input v-model="form.price30" icon="currency-usd-circle"></b-input>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-button :disabled="!isValid" type="is-info" native-type="submit">{{
              $ml.get('common_save')
            }}
          </b-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from "vue";
import router from "@/router";
import {mapGetters} from "vuex";

export default {
  name: "Create",
  data() {
    return {
      form: {
        id: null,
        bookmaker: '',
        min_payments: 0,
        price7: 0,
        price30: 0,
      },
      loading: false,
      errors: [],
      usedBookies: [],
    }
  },
  computed: {
    ...mapGetters('data', ['bookmakers',]),
    isValid() {
      return this.form.bookmaker.length > 0;
    },
  },
  methods: {
    submit: function () {
      this.loading = true
      this.errors = []
      if (!this.form.min_payments) {
        this.form.min_payments = 1;
      }
      if (!this.form.price7) {
        this.form.price7 = 20;
      }
      if (!this.form.price30) {
        this.form.price30 = 65;
      }
      Vue.prototype.$http.post(process.env.VUE_APP_API_HOST + 'bookies/index', {bookie: this.form}).then(resp => {
        this.flashMessage.success({
          title: this.$ml.get('common_request_success'),
          message: this.$ml.get('common_request_success_data_message'),
        })
        router.push('/bookies')
      }).catch(err => {
        if (err.response.status === 400) {
          this.errors = err.response.data.result
        } else {
          this.flashMessage.error({
            title: this.$ml.get('common_request_failed'),
            message: this.$ml.get('common_request_failed_message'),
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
  },
  mounted() {
    let id = this.$route.query.id
    if (id) {
      this.loading = true
      Vue.prototype.$http.get(process.env.VUE_APP_API_HOST + `bookies/index?id=${id}`).then((resp) => {
        this.form = resp.data.result
      }).catch(err => {
        this.flashMessage.error({
          title: this.$ml.get('common_request_failed'),
          message: this.$ml.get('common_request_failed_message'),
        })
      }).finally(() => {
        this.loading = false
      })
    }
    this.loading = true
    Vue.prototype.$http.get(process.env.VUE_APP_API_HOST + `bookies/used` +
        (id ? `?id=${id}` : '')).then((resp) => {
      console.log(resp);
      this.usedBookies = resp.data.result.used;
      console.log(this.usedBookies);
    }).catch(err => {
      this.flashMessage.error({
        title: this.$ml.get('common_request_failed'),
        message: this.$ml.get('common_request_failed_message'),
      })
    }).finally(() => {
      this.loading = false
    })
  },
  metaInfo() {
    return {
      title: this.$ml.get('titles_bookies_new')
    }
  }
}
</script>

<style scoped>
</style>
